import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const ArrowExpandIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' {...props} ref={ref}>
        <path
            fill='currentColor'
            d='M17 2C16.4477 2 16 2.44772 16 3C16 3.55228 16.4477 4 17 4L18.5858 4L14.2929 8.29289C13.9024 8.68342 13.9024 9.31658 14.2929 9.70711C14.6834 10.0976 15.3166 10.0976 15.7071 9.70711L20 5.41422L20 7.00001C20 7.55229 20.4477 8 21 8C21.5523 8 22 7.55229 22 7L22 3C22 2.44772 21.5523 2 21 2H17ZM4 18.5858L4 17C4 16.4477 3.55228 16 3 16C2.44771 16 2 16.4477 2 17L2 21C2 21.5523 2.44772 22 3 22H7C7.55228 22 8 21.5523 8 21C8 20.4477 7.55229 20 7 20H5.41421L9.70711 15.7071C10.0976 15.3166 10.0976 14.6834 9.70711 14.2929C9.31658 13.9024 8.68342 13.9024 8.29289 14.2929L4 18.5858Z'
        />
    </svg>
));
